import { useCallback } from 'react';
import { fireIssueTransitionErrorAnalytics as fireErrorAnalytics } from '@atlassian/jira-issue-transition-analytics/src/utils/fire-error-analytics/index.tsx';
import { useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { useIssueTypeName } from '@atlassian/jira-issue-context-service/src/context.tsx';
import { getTransitionSuccessFlag, getTransitionFailureFlag } from './utils.tsx';

/**
 *
 * @returns a set of methods that can be used to shw flags.
 * The idea of this hook was to contain all the flags that we will use across the issue transition.
 * Keeps all the flags and their test can be separeted.
 */
export const useShowFlag = () => {
	const { showFlag } = useFlagsService();
	const { formatMessage } = useIntl();
	const [workType] = useIssueTypeName();

	const showIssueTransitionSuccessFlag = useCallback(
		(issueKey: string, status: string) => {
			try {
				showFlag(getTransitionSuccessFlag(issueKey, status, formatMessage, workType));
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireErrorAnalytics({
					meta: {
						id: 'showSuccessFlag',
						packageName: 'jiraIssueTransitionUseShowFlag',
						teamName: 'gryffindor',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
			}
		},
		[formatMessage, showFlag, workType],
	);
	const showIssueTransitionFailureFlag = useCallback(
		(issueKey: string, traceId?: string) =>
			showFlag(getTransitionFailureFlag(issueKey, formatMessage, traceId, workType)),
		[formatMessage, showFlag, workType],
	);

	return {
		showIssueTransitionSuccessFlag,
		showIssueTransitionFailureFlag,
	};
};
